import React from 'react';

import { ContainerFooterMobile, ContainerTextAndIconFooter, IconsFooter } from './style';

import WhiteWhatsappIconSVG from '../../../assets/images/footerCheckout/white-whatsapp-icon.svg';
import WhiteMailIconSVG from '../../../assets/images/footerCheckout/white-mail-icon.svg';
import WhiteLineIconSVG from '../../../assets/images/footerCheckout/white-line.svg';

export default function FooterCheckout(): JSX.Element {
  const currentYear = new Date().getFullYear();

  return (
    <ContainerFooterMobile>
      <ContainerTextAndIconFooter>
        Resolva Meu Look © {currentYear} - Todos os direitos reservados
      </ContainerTextAndIconFooter>
      <ContainerTextAndIconFooter>
        <IconsFooter src={WhiteWhatsappIconSVG} widthIcon="3.536vw" heightIcon="3.536vw" />
        (11) 93400 9574
        <IconsFooter
          src={WhiteLineIconSVG}
          marginMobile="0 2.666vw 0 2.666vw"
          widthIcon="3.536vw"
          heightIcon="3.536vw"
        />
        <IconsFooter src={WhiteMailIconSVG} widthIcon="3.733vw" heightIcon="2.8vw" />
        atendimento@resolvameulook.com
      </ContainerTextAndIconFooter>
    </ContainerFooterMobile>
  );
}
